import { C } from '../../theme.js';
import { Alert, Eyebrow } from '../../components/Primitives.jsx';
import { MultiColsDropdown } from './MultiColsDropdown.jsx';
import { hasUpstreamSplit } from '../../data.js';
import { OutputColumnNamesField } from '../shared/OutputColumnNamesField.jsx';

/**
 * OneHotEncodingInspector
 * Creates binary dummy columns for each category.
 */
export function OneHotEncodingInspector({ step, onChange, pipeline }) {
  const c = step.config || {};
  const sel = Array.isArray(c.columns) ? c.columns : (c.column ? [c.column] : []);
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  const splitReady = pipeline ? hasUpstreamSplit(pipeline.steps, step.id) : true;

  return (
    <div>
      <Eyebrow>One-Hot Encoding</Eyebrow>
      <div style={{ color: C.fg4, fontSize: '.78rem', margin: '4px 0 10px', lineHeight: 1.5 }}>
        Create a new binary (0/1) column for each unique category found in the selected columns.
      </div>
      {!splitReady && (
        <Alert kind="warn" style={{ marginBottom: 10 }}>
          No Train / Test Split step found upstream — this will fit using all rows. If the result feeds a model, add a Train / Test Split step first to avoid data leakage.
        </Alert>
      )}
      <MultiColsDropdown selected={sel} onChange={(v) => u({ columns: v, column: v[0] || null })} categorical />
      <OutputColumnNamesField
        columns={sel}
        value={c.output_columns}
        onChange={(v) => u({ output_columns: v })}
        legacyValue={c.output_column}
        autoName={(col) => col}
        label="Output Column Prefix(es) (Optional)"
        hint="Optional — override the prefix used for each selected column's dummy columns (<prefix>_<category>). Defaults to the column's own name."
      />
    </div>
  );
}
